var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageLogin',{attrs:{"namePage":"login-usuario","title":"Login do usuário","subtitle":"Entre com um e-mail e senha do usuário","profissional":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }